/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('wrBookmark', ["BookmarksModel", "DocumentService", "DocumentModel", "BookmarksService", "$rootScope", "$compile", function(BookmarksModel, DocumentService, DocumentModel, BookmarksService, $rootScope, $compile) {
        return {
            scope: {
                bookmarkIndex: '=',
                book: "=",
                bookOffset: '=',
                uuid: "="
            },
            require: '?chaptercollection',
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'directives/bookmarkitem/bookmark-item.view.html',
            controller: ["$scope", "BookmarksModel", "DocumentService", "DocumentModel", "BookmarksService", "$rootScope", "NetworkService", "$timeout", function($scope, BookmarksModel, DocumentService, DocumentModel, BookmarksService, $rootScope, NetworkService, $timeout) {
                var scope = $scope;
                var loadCallback;
                var uuid = scope.uuid;
                scope.deleteBookmark = function() {
                    BookmarksModel.removeBookmark(scope.bookmark.uuid);
                };
                scope.page = "...Load";
                /*$timeout(function() {
                    NetworkService.getBookmark(DocumentModel.getDocumentPath(), uuid)
                        .then(function(res) {
                            var start_pointer = DocumentService.parseCfiPosition(res.mark.anchor);
                            var chapterIndex = DocumentModel.getChapterIdByUrl(start_pointer.url);
                            var refObj = DocumentService.getChapterOffsetObject(start_pointer.offsetChar, chapterIndex);
                            var viewportOffset = angular.element(refObj.element).position().top;
                            scope.page = Math.ceil(DocumentService.getTotalPagesCount() * (DocumentModel.getPreviousChaptersLength() +
                                (DocumentModel.getLoadedContentLength() *
                                    (viewportOffset / angular.element('content-wrapper').height()))) / DocumentModel.getTotalContentLength());
                        })
                        .catch(function(reason) {
                            // console.log(reason);
                        });
                }, 1000);*/
               
                scope.navigate = function(book) {
                    var str = angular.copy(book.mark.anchor);
                    var epubcfi = '#epubcfi';
                    var beginIndx = str.search(epubcfi);
                    var resSting = str.substr(beginIndx, str.length);
                    var cfi_position = resSting.match(/\/\d+/ig);
                    var charCfiPosition = resSting.match(/\:\d+/ig);
                    var concatArr = cfi_position.concat(charCfiPosition)
                    var repleseAll = concatArr.join().replace(/,/g, '');
                    var result = epubcfi + '(' + repleseAll + ')';
                    DocumentService.scrollDocumentToChapter(null, result);
                };

                if (BookmarksModel.checkIf.isBookmarkLoaded(scope.bookmarkIndex)) {

                    scope.bookmark = BookmarksModel.getBookmarkByIndex(scope.bookmarkIndex);
                    //  console.log( scope.bookmark, 'scope bookmark')
                } else {
                    loadCallback = BookmarksModel.subscribe.onBookmarkLoaded(scope.bookmarkIndex, function() {
                        BookmarksModel.unsubscribe.onBookmarkLoaded(scope.bookmarkIndex, loadCallback);
                        scope.bookmark = BookmarksModel.getBookmarkByIndex(scope.bookmarkIndex);
                    });
                }
            }],
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, elem) {
                        //   console.log('post',scope, elem, scope.bookmark);
                    }
                }
            }
        };
    }]);